module.exports = __webpack_public_path__ + "static/media/Physics Learner.e0f5cf16.jpg";